import { FrontendUrls } from '../types/urls'

/**
 * Returns the appropriate dashboard URL based on user role
 * @param userRole - The role of the user ('Admin', 'Approver', 'User')
 * @returns The appropriate dashboard URL
 */
export const getDashboardUrl = (userRole?: string): string => {
  return userRole === 'User' ? FrontendUrls.userDashboard : FrontendUrls.dashboard
}